export const GET_HOUSE_TYPES = "GET_HOUSE_TYPES";
export const GET_STATES = "GET_STATES";
export const GET_LOCATIONS = "GET_LOCATIONS";
export const LOCATION_LOADING = "LOCATION_LOADING";
export const CALCULATING = "CALCULATING";
export const GET_CALCULATION = "GET_CALCULATION";
export const FETCH_CALCULATION = "FETCH_CALCULATION";
export const FETCH_DOWN_PAY = "FETCH_DOWN_PAY";
export const FETCH_DOWN_PAY_STATUS = "FETCH_DOWN_PAY_STATUS";
